module.exports = __webpack_public_path__ + "img/reconciliationCenter.8ee2e414.png";